import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "self-stretch py-1 flex justify-start items-start gap-2"
}
const _hoisted_2 = { class: "w-4 h-4 relative" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "flex-1 inline-flex flex-col justify-center items-start" }
const _hoisted_5 = { class: "self-stretch py-1 flex justify-start items-start gap-2.5" }
const _hoisted_6 = {
  "data-type": "close",
  class: "w-4 h-4 relative"
}
const _hoisted_7 = ["src"]

import { IToastAlert } from '@/interfaces/components/toast-alert.interface';
import { ToastAlertMeta } from '@/store/toast-alert/toast-alert.state'

type toastAlertEmits = (e: 'close', id: number) => void;

export default /*@__PURE__*/_defineComponent({
  __name: 'ToastAlert',
  props: {
    toastAlert: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const meta = ToastAlertMeta[props.toastAlert.type];

const onCloseClicked = () => {
  emit('close', props.toastAlert.id);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['inline-flex max-md:w-[calc(100%-2rem)] w-full racq-max-w-xl3 pl-4 pr-5 py-4 rounded-lg shadow-outer justify-start items-center gap-4', _unref(meta).backgroundColour])
  }, [
    (!!_unref(meta).icon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              src: _unref(meta).icon,
              alt: `${_ctx.toastAlert.type} icon`,
              class: "w-4 h-4"
            }, null, 8, _hoisted_3)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: _normalizeClass(['self-stretch justify-center text-base-bold leading-normal', _unref(meta).textColour])
      }, _toDisplayString(_ctx.toastAlert.title), 3),
      _createElementVNode("div", {
        class: _normalizeClass(['self-stretch justify-center text-m leading-tight', _unref(meta).textColour])
      }, _toDisplayString(_ctx.toastAlert.description), 3)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "cursor-pointer",
          onClick: onCloseClicked,
          "aria-label": "Close toast alert"
        }, [
          _createElementVNode("img", {
            src: _unref(meta).closeIcon,
            alt: "close icon",
            class: "w-4 h-4"
          }, null, 8, _hoisted_7)
        ])
      ])
    ])
  ], 2))
}
}

})